module.exports = __webpack_public_path__ + "img/green_vee_spot.9f78bf97.svg";